import React from "react"

import MyWorkView from "../../model/my-work-view";
import MyWorkAppProto from "../../app-proto";
import openMyWorkView from "../../../actions/open-my-work-view";
import {EVENT_BUS_MY_WORK_SUBMENU_CHANGED} from "../../@const";
import PopoverMenuOption from "../../../../../../core/gd-components/popover-menu/popover-menu/menu-option";
import {PopoverMenuItemType} from "../../../../../../core/gd-components/popover-menu/popover-menu/const";
import PopoverMenuOptionWithSubmenu
    from "../../../../../../core/gd-components/popover-menu/popover-menu/option-with-submenu/menu-option-with-submenu";

type Props = {
    className?  : string
    menuParams  : {
        view : MyWorkView,
        isMoreItem?: boolean
    }
    hidePopover? : callback
}

// const debug = "MyWorkSubmenuItem_More"
const debug = false

export default class MyWorkSubmenuItem_More extends React.Component<Props> {

    public app: MyWorkAppProto

    constructor(props: Props) {
        super(props)

        this.app = gd.getApp()
    }

    onRename = ()=> {

        if (this.props.hidePopover) {
            this.props.hidePopover()
        }

        const view = this.props.menuParams.view

        gd.modals.oneInput('Name', view.name, 'Rename', async (newName) => {
            gd.modal.hide()

            view.name = newName

            // Refresh project menu
            gd.top.reRender()

            // save new project view name
            this.app.viewsCollection.save()
        })

        // this.props.menuParams.view
    }

    onDelete = () => {

        this.app.viewsCollection.remove(this.props.menuParams.view.id)
        this.app.viewsCollection.save()

        if (this.app.localSettingsMyWorkGlobal.currentViewId === this.props.menuParams.view.id) {
            openMyWorkView(this.app, this.app.viewsCollection.models[0])
        } else {
            gd.bus.triggerEvent(EVENT_BUS_MY_WORK_SUBMENU_CHANGED)
        }

        if (this.props.hidePopover) {
            this.props.hidePopover()
        }
    }

    onMoveLeft = ()=> {
        this.app.viewsCollection.moveLeft(this.props.menuParams.view)
        gd.bus.triggerEvent(EVENT_BUS_MY_WORK_SUBMENU_CHANGED)

        if (this.props.hidePopover) {
            this.props.hidePopover()
        }
    }

    onMoveRight = ()=> {
        this.app.viewsCollection.moveRight(this.props.menuParams.view)
        gd.bus.triggerEvent(EVENT_BUS_MY_WORK_SUBMENU_CHANGED)

        if (this.props.hidePopover) {
            this.props.hidePopover()
        }
    }

    onMoveToStart = ()=> {
        this.app.viewsCollection.moveToStart(this.props.menuParams.view)
        gd.bus.triggerEvent(EVENT_BUS_MY_WORK_SUBMENU_CHANGED)

        if (this.props.hidePopover) {
            this.props.hidePopover()
        }
    }

    onMoveToEnd = ()=> {
        this.app.viewsCollection.moveToEnd(this.props.menuParams.view)
        gd.bus.triggerEvent(EVENT_BUS_MY_WORK_SUBMENU_CHANGED)

        if (this.props.hidePopover) {
            this.props.hidePopover()
        }
    }

    render() {

        const classes = Classes("ui5-popover-menu w-200", this.props.className)

        const moveOptions: Options = [
            {
                type    : PopoverMenuItemType.ITEM,
                icon    : "i5-long-arrow-left",
                label   : "Move Left",
                disabled: this.props.menuParams.view.sortPosition === 0,
                onClick : this.onMoveLeft
            },
            {
                type    : PopoverMenuItemType.ITEM,
                icon    : "i5-long-arrow-right",
                label   : "Move Right",
                disabled: this.app.viewsCollection.length === this.props.menuParams.view.sortPosition + 1,
                onClick : this.onMoveRight
            },
            {
                type    : PopoverMenuItemType.ITEM,
                icon    : "i5-make-first",
                label   : "Make First",
                disabled: this.props.menuParams.view.sortPosition === 0,
                onClick : this.onMoveToStart
            },
            {
                type    : PopoverMenuItemType.ITEM,
                icon    : "i5-make-last",
                label   : "Make Last",
                disabled: this.app.viewsCollection.length === this.props.menuParams.view.sortPosition + 1,
                onClick : this.onMoveToEnd
            },
        ]

        const options: Options = [
            {
                type    : PopoverMenuItemType.ITEM,
                icon    : "i5-pen",
                label   : "Rename",
                onClick : this.onRename
            }
        ]

        if (!this.props.menuParams.isMoreItem) {
            options.push({
                type    : PopoverMenuItemType.SUBMENU,
                icon    : "i5-move-column",
                label   : "Move",
                disabled: this.app.viewsCollection.models.length === 1,
                options : moveOptions
            })
        }

        options.push({
            type    : PopoverMenuItemType.ITEM,
            icon    : "i5-trash-alt",
            label   : "Delete",
            disabled: this.app.viewsCollection.models.length === 1,
            onClick : this.onDelete
        })


        return (
            <div className={classes}>

                {_.map(options, (option: Option, key: number) => {

                    if (option.type === PopoverMenuItemType.SUBMENU) {
                        return <PopoverMenuOptionWithSubmenu key        = {key}
                                                             className  = "view-more-submenu-item"
                                                             option     = {option}/>
                    }

                    return <PopoverMenuOption key={key} option={option}/>
                })}

            </div>
        )
    }
}
